/**
 * MHH Experience System — Decision Zone (Sprint 3)
 * Scroll-in stagger for outcome bullets (once). Respects reduced motion.
 */
(function () {
  function initDecisionZone(root) {
    if (!root || root.getAttribute('data-mhh-exp-decision-ready') === '1') return;
    root.setAttribute('data-mhh-exp-decision-ready', '1');

    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('is-revealed');
          observer.disconnect();
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-mhh-exp-decision]').forEach(initDecisionZone);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var node = event.target.querySelector
      ? event.target.querySelector('[data-mhh-exp-decision]')
      : null;
    if (node) initDecisionZone(node);
    if (event.target.matches && event.target.matches('[data-mhh-exp-decision]')) {
      initDecisionZone(event.target);
    }
  });
})();
